export const END_COUNTER = 'BETTER LUCK NEXT TIME!'
export const CONGRATS_FIND_ALL = 'CONGRATS! YOU FOUND THEM ALL.'
export const ANIMATION_DURATION = 1400
export const CIRCLE_SIZE = 30

export const MODAL_NEUTRAL_TITLE = 'Well done!'
export const MODAL_NEUTRAL_SUBTITLE = 'Thanks for playing.'

export const MODAL_WIN_TITLE = 'Well done!'
export const MODAL_WIN_SUBTITLE = 'You found all the matches.'
export const MODAL_LOSE_TITLE = 'Better luck next time!'
export const MODAL_LOSE_SUBTITLE = ({ correctNumber, totalNumber }) =>
  `You missed ${totalNumber - correctNumber} of the matches.`

export const GAME_TYPE = {
  PAIRS: 'pairs',
  RANKING: 'ranking',
  ORDER: 'order',
}
